module.exports = __webpack_public_path__ + "img/1542517994.44123719.jpg";